import React, { Component } from 'react';
import Select from 'react-select';
import { api_url } from "../globalFunction/global_string";

export class ReactSelectUnit extends Component {
  static displayName = ReactSelectUnit.name;

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      name: props.name,
      requiredAPI: props.requiredAPI,
      options: [],
      selectedOption: null,
      local_net_id: '',
      local_unit_id: '',
      current_user_type: localStorage.getItem('login_user_type'),
      parentName: props.parentName,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    let { parentName } = this.props;

    if (parentName === 'Statistical' && prevProps.formData.statistical_net_name !== this.props.formData.statistical_net_name) {
      this.loadData();
    } else if (parentName === 'superS') {
      if (prevProps.selectnet !== this.props.selectnet || prevProps.local_net_name !== this.props.local_net_name) {
        this.loadData();
      }
    }
  }

  loadData() {
    let apiUrl = api_url + this.state.requiredAPI;
    let { parentName } = this.props;
    const formData = new FormData();

    if (parentName === 'Excel') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
    } else if (parentName === 'superS') {
      formData.append("local_net_id", this.props.selectnet);
      formData.append("local_net_name", this.props.local_net_name);
    } else if (parentName === 'superM') {
      formData.append("current_user_type", localStorage.getItem('login_user_type'));
      formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
      formData.append("local_net_name", this.props.local_net_name);
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log("✅ API 回傳資料:", data);
        let arr_status = [String(data.statusCode), data.row, data.detail];
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];

        // ✅ 轉換成 react-select 格式
        const formattedOptions = rows.map(option => ({
          value: option.local_unit_id,
          label: option.local_unit_name
        }));

        this.setState({ options: formattedOptions });
      })
      .catch(error => {
        console.error('❌ Error:', error);
      });
  }

  handleSelectChange = (selectedOption) => {
    this.setState({ selectedOption });

    this.props.onUnitSelectChange({
      name: this.state.name,
      value: selectedOption?.value || "",
      selectedName: selectedOption?.label || ""
    });
  };

  render() {
    return (
      <Select
        id={this.state.id}
        name={this.state.name}
        value={this.state.selectedOption}
        onChange={this.handleSelectChange}
        options={this.state.options}
        placeholder="請選擇單位"
        isClearable
        isSearchable
      />
    );
  }
}
